import { FunctionComponent, memo, useContext } from "react";
import { Form, Formik } from "formik";
import { SelectField } from "@edgetier/select";
import { Button, SubmitOnChange } from "@edgetier/components";
import { InteractionContext } from "components-for/interactions/interaction-context/interaction-context";
import useTagGroups from "hooks-for/tag-groups/use-tag-groups";
import { IFormValues, IProps } from "./select-tag-groups-form.types";
import { ITagGroup, TagGroupType } from "@edgetier/watchtower-types";
import "./select-tag-groups-form.scss";
import { faTimes } from "@fortawesome/pro-solid-svg-icons";

/**
 * Form component to create a tag group
 * @param props.selectedTagGroups   Tag groups from interaction tags
 * @param props.onSelectTagGroup    Callback to update interaction tag groups
 */
const SelectTagGroupsForm: FunctionComponent<IProps> = ({ selectedTagGroups, onSelectTagGroup }) => {
    const { data: tagGroups, isLoading } = useTagGroups({ tagGroupType: TagGroupType.PhraseSearch });
    const { setIsAddTagGroupSelectVisible } = useContext(InteractionContext);

    const availableTagGroups = (tagGroups ?? []).filter((tagGroup) => !selectedTagGroups.includes(tagGroup.tagGroup));

    // Form submit, find and send tag group name
    const onSubmit = (data: IFormValues) => {
        // Hide dropdown select for tag groups
        setIsAddTagGroupSelectVisible(false);

        const tagGroup = (tagGroups ?? []).find(({ tagGroupId }) => tagGroupId === data.tagGroup);

        if (typeof tagGroup !== "undefined") {
            onSelectTagGroup(tagGroup.tagGroup);
        }
    };

    return (
        <div className="select-tag-groups">
            <Formik<IFormValues> initialValues={{ tagGroup: "" }} onSubmit={onSubmit}>
                <Form name="select-tag-groups">
                    <div className="select-tag-groups__header">
                        <label htmlFor="tagGroup">New Tag Group</label>
                        <Button
                            isIconOnly
                            icon={faTimes}
                            size="small"
                            isUnstyled
                            className="select-tag-groups__remove-button"
                            onClick={() => setIsAddTagGroupSelectVisible(false)}
                        />
                    </div>
                    <SelectField<ITagGroup, string>
                        labelledBy="tagGroup"
                        items={availableTagGroups}
                        isSingleSelect
                        isLoading={isLoading}
                        name="tagGroup"
                        description="tag group"
                        getLabel={({ tagGroup }) => tagGroup}
                        getValue={({ tagGroupId }) => tagGroupId}
                    />

                    <SubmitOnChange delay={0} />
                </Form>
            </Formik>
        </div>
    );
};

export default memo(SelectTagGroupsForm);
